export const MED = {
  navMedications: "nav-medications",
  page: "medications-page",
  title: "medications-title",
  banner: "medications-reference-banner",
  table: "medications-table",
  loading: "medications-loading",
  emptyState: "medications-empty",
  errorState: "medications-error",
  row: "medications-row",
};
